import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LocaleContext } from "../../routing/LangRouter";
import { Container, Typography, Box, Link } from "@mui/material";
import ConfettiExplosion from "react-confetti-explosion";

//import utils
import { navigateToLoginPage } from "../../utils/utility";

//import general components
import EventTimer from "../../components/view/event/EventTimer";
import EventForm from "../../components/view/event/EventForm";

const EventRegistration = () => {
    //genral
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        if (!accessToken) {
            navigateToLoginPage(navigate, locale, location);
            return;
        }
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: "#006363",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                p: 0,
                m: 0, // Explicitly set margin to 0
                width: "100%", // Ensure full width
                overflow: "hidden", // Prevent any overflow issues
                pb: { xs: 2, md: 40 }, // Add padding bottom for mobile view
                pt: { xs: 2 },
            }}
        >
            <Container
                maxWidth={false} // Use false instead of "lg" to remove width constraints
                disableGutters
                sx={{
                    p: 0,
                    m: 0,
                    width: "100%",
                    maxWidth: "100%", // Override any max-width
                    pr: { xs: 2, md: 0 }, // Apply negative margin to counteract any remaining padding
                    pl: { xs: 2, md: 24 },
                }}
            >
                {/* Use display flex instead of Grid for more direct control */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        gap: 4,
                    }}
                >
                    {/* Event Details */}
                    <Box sx={{ flex: 1, width: { xs: "100%", md: "50%" }, display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Box>
                            <Typography
                                sx={{
                                    typography: {
                                        xs: "h5", // Mobile
                                        md: "h4", // Desktop
                                    },
                                    textAlign: { xs: "center", md: "left" },
                                    fontWeight: "bold",
                                    color: "white",
                                    pb: 3,
                                }}
                                gutterBottom
                            >
                                تبریک! تو خیلی خوش شانسی!
                            </Typography>

                            <Typography
                                variant="h2"
                                color="white"
                                sx={{ pb: 3, fontSize: { xs: "16px", md: "20px" }, lineHeight: { xs: "28px", md: "32px" } }}
                            >
                                بلیطت رو پیدا کردی و میتونی همین الان با پر کردن فرم، رمز کارت <b>500,000 تومنی </b>
                                رو دریافت کنی! حالا وقتشه وارد دنیای جایزه و سفر های هیجان انگیز آتریپا بشی!
                            </Typography>
                            <Typography
                                variant="h1"
                                color="white"
                                sx={{ fontSize: { xs: "14px", md: "17px" }, lineHeight: { xs: "24px", md: "28px" } }}
                            >
                                *در ضمن همراهتم میتونه جایزشو تو ایونت حضوری بگیره... پس حتما تو ایونت حضور داشته باشین
                            </Typography>
                        </Box>

                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="#FFD400"
                            gutterBottom
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mt: 4,
                            }}
                        >
                            فرصت باقیمانده:
                        </Typography>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "white",
                                p: 2,
                                borderRadius: 2,
                                width: "fit-content",
                                // width: {xs:"fit-content",md:"50%"},
                                // height: {md:"100px"},
                            }}
                        >
                            <EventTimer />
                        </Box>
                    </Box>

                    {/* card-password image */}

                    <Box sx={{ display: { xs: "none", md: "block" }, pt: 35 }}>
                        <img
                            src="/Group 745.png"
                            alt="card-password-image"
                            style={{
                                maxWidth: "100%",
                                display: "block",
                            }}
                        />
                        <ConfettiExplosion force={0.8} duration={3000} particleCount={250} width={1600} />
                    </Box>

                    {/* Registration Form & Image */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { md: "row" },
                            alignItems: "center",
                            flex: 1,
                            width: { xs: "100%", md: "50%" },
                            overflow: "hidden",
                        }}
                    >
                        {/* Registration Form */}
                        <Box
                            sx={{
                                flex: 1.3,
                                pr: { md: 0 }, // In RTL, padding-left controls the right visual side
                                mr: { md: 0 },
                                mt: { xs: 2, md: 3 },
                            }}
                        >
                            <EventForm />
                        </Box>

                        {/* Image - Use negative margin considering RTL */}
                        <Box
                            sx={{
                                flex: 1,
                                display: { xs: "none", md: "flex" },
                                justifyContent: "flex-end",
                                ml: -10, // In RTL, margin-right pulls the image closer from the left visual side
                                mt: 13,
                            }}
                        >
                            <img
                                src="/atripa-robot.png"
                                alt="Event Registration"
                                style={{
                                    maxWidth: "100%",
                                    display: "block",
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: { md: "block" },
                        mt: "100px",
                        // ml: {  md: -20 }, // cancel horizontal padding
                    }}
                >
                    <Typography variant="h6" color="white" fontWeight="bold" sx={{ mb: 1, textAlign: { xs: "center", md: "left" } }}>
                        برنامه ایونت حضوری آتریپا:
                    </Typography>

                    {/* Mobile image */}
                    <Box
                        sx={{
                            display: { xs: "flex", md: "none" }, // switch to flex for centering
                            justifyContent: "center", // centers image horizontally
                            mt: "30px", // apply margin top to the container instead of image
                        }}
                    >
                        <img
                            src="/Group 742.png"
                            alt="first-event-picture-mobile"
                            style={{
                                maxWidth: "50%",
                                display: "block",
                            }}
                        />
                    </Box>

                    {/* Desktop image */}
                    <Box sx={{ display: { xs: "none", md: "block" } }}>
                        <img
                            src="/Group 726.png"
                            alt="first-event-picture-desktop"
                            style={{
                                marginTop: "30px",
                                maxWidth: "90%",
                                display: "block",
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            mt: "50px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {/*desktop */}
                        <Box
                            component="img"
                            src="/Frame 35166.png"
                            alt="second-event-picture-desktop"
                            sx={{
                                maxWidth: { md: "90%" }, // 300px width on mobile, auto on desktop
                                height: { md: "40%" }, // 200px height on mobile, auto on desktop
                                pr: { md: 19 }, // remove padding on mobile
                                // display: "block",
                                display: { xs: "none", md: "block" },
                            }}
                        />
                        {/* mobile*/}
                        <Box
                            component="img"
                            src="/Frame 3517.png"
                            alt="second-event-picture-mobile"
                            sx={{
                                maxWidth: { xs: "100%" }, // 300px width on mobile, auto on desktop
                                height: { xs: "170px" }, // 200px height on mobile, auto on desktop
                                pr: { xs: 0 }, // remove padding on mobile
                                display: { xs: "block", md: "none" },
                            }}
                        />
                    </Box>
                </Box>
                <Typography variant="h6" color="white" fontWeight="bold" sx={{ mb: 2, mt: 5 }}>
                    قوانین مهم ایونت حضوری:
                </Typography>
                <Typography variant="h2" color="white" sx={{ fontSize: { xs: "16px", md: "20px" }, mb: 1 }}>
                    - فقط با <b>ثبت نام</b> میتونی رمز کارتت رو بگیری.
                </Typography>
                <Typography variant="h2" color="white" sx={{ fontSize: { xs: "16px", md: "20px" }, mb: 1, lineHeight: { xs: "28px", md: "32px" } }}>
                    - <b>کارت پیدا شده + تکه پازل</b> رو نگه دار و روز ایونت با خودت بیار.
                </Typography>
                <Typography variant="h2" color="white" sx={{ fontSize: { xs: "16px", md: "20px" }, mb: 1, lineHeight: { xs: "28px", md: "32px" } }}>
                    - شرکت کننده اصلی باید <b>بالای 18 سال</b> باشه. اگر کمتر از 18 سالته و کارت رو پیدا کردی میتونی اون رو به خانواده یا دوستات بدی.
                </Typography>
                <Typography variant="h2" color="white" sx={{ fontSize: { xs: "16px", md: "20px" }, mb: 1, lineHeight: { xs: "28px", md: "32px" } }}>
                    - یه عکس <b>سلفی با قاب</b> از خودت بگیر. به بهترین عکس سلفی منتخب مردم <b>سفر به کیش</b> هدیه داده می شود.
                </Typography>
                <Typography
                    variant="h2"
                    color="white"
                    sx={{
                        fontSize: { xs: "16px", md: "20px" },
                        mb: 1,
                        lineHeight: { xs: "28px", md: "32px" },
                    }}
                >
                    - حتما پیج ما رو در اینستاگرام دنبال کن تا از جدیدترین اخبار ایونت با خبر بشی:{" "}
                    <Link
                        href="https://www.instagram.com/atripa_ai?igsh=NmdwbzFrMW1zcGhq"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{ fontWeight: "bold", color: "white" }}
                    >
                        atripa_ai@
                    </Link>
                </Typography>
            </Container>
        </Box>
    );
};

export default EventRegistration;

